export const ALL_DROPDOWN_OPTION = {
  label: "All",
  value: "",
};
